import { Avatar, Box, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import React from "react";
import { useAuthContext } from "../AuthContextWrapper";

interface Props {
  isPositionAbsolute?: boolean;
}

export const AuthCircle = (): JSX.Element => {
  const { user, signOutUser, avatarImageData } = useAuthContext()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  
  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSignOut = async () => {
    handleClose();
    await signOutUser();
  };
  
  return  <div onMouseLeave={handleClose} style={{position:"absolute", right:"1rem", top:"0rem", zIndex:20,}}>
    <IconButton 
      onClick={handleOpen} 
      onMouseEnter={handleOpen} 
      sx={{
        background: "linear-gradient(90deg, #643bae 0%, #3538c9 100%)", 
        borderRadius: "50%",
        width: "40px",
        height: "40px",
      }}
    >
      {(!user?.initials || avatarImageData) && <Avatar  
        src={avatarImageData ?`data:;base64,${avatarImageData}` : undefined} 
        style={{backgroundColor: "transparent"}}
        alt="avatar" 
      />}
      {(user?.initials && !avatarImageData) && <Typography sx={{color: "white", fontFamily:"sans-serif", fontSize:"20px",fontWeight:700}}>
        {user?.initials}
      </Typography>}
    </IconButton>
    <Menu
      anchorEl={anchorEl}
      open={!!anchorEl}
      onClose={handleClose}
      onMouseLeave={handleClose}
    >
      <MenuItem onClick={handleSignOut}>Sign out</MenuItem>
    </Menu>
  </div>
};
